import { useQuery } from 'react-query';
import { API } from '../../../CommonUtils/axiosWithDefaults';
import { POLL_INTERVAL_MS } from '../meta';
import { ReconciliationStatusResult } from '../pdfReconciliationTypes';
import { queryKeys } from './queryKeys';

const TERMINAL_STATUSES: ReconciliationStatusResult['status'][] = [
  'AwaitingReview',
  'Applied',
  'Failed',
  'Skipped',
  'Cancelled',
];

interface QueryParams {
  batchId: string | null;
  itemId: string | null;
  enabled: boolean;
}

const fetchReconciliation = async (batchId: string, itemId: string): Promise<ReconciliationStatusResult> => {
  return API.get(
    `/Adviser/PdfImport/Reconciliation?batchId=${encodeURIComponent(batchId)}&itemId=${encodeURIComponent(itemId)}`,
  );
};

export const useReconciliationProposalQuery = ({ batchId, itemId, enabled }: QueryParams) => {
  return useQuery<ReconciliationStatusResult>(
    queryKeys.reconciliation(batchId, itemId),
    () => fetchReconciliation(batchId as string, itemId as string),
    {
      enabled: !!(enabled && batchId && itemId),
      refetchInterval: data => {
        if (!data) return POLL_INTERVAL_MS;
        return TERMINAL_STATUSES.includes(data.status) ? false : POLL_INTERVAL_MS;
      },
      refetchOnWindowFocus: false,
    },
  );
};
